<template>
  <page>
    <module title="我的账户" enable-flex>
      <div class="account flex-wrap">
		<div class="item flex-grow flex-end">
			<div class="flex-grow">
				<label>账户余额（元）</label>
				<div class="flex-baseline">
					<strong>{{account.account_balance}}</strong>
					<span>可提现金额：{{account.can_withdraw_balance}}</span>
				</div>
			</div>
			<c-button class="button" color="main" @click="navigateTo('/account_extract');" :disabled="account.can_withdraw_balance <= 0">提现</c-button>
		</div>

		<div class="item flex-grow">
			<label>品质保障额度（元）</label>
			<div>
				<strong>{{account.deposit_money}}</strong>
			</div>
		</div>

		<div class="item flex-grow flex-end">
			<div class="flex-grow">
				<label>待结算货款（元）</label>
				<div>
					<strong>{{account.settle_amount}}</strong>
				</div>
			</div>
            <c-button class="button" @click="navigateTo('/settlement_record');">查看详情</c-button>
		</div>
      </div>
	  
	  <div class="flex-between-center" style="padding: 0 20px 10px;">
		  <c-title>资金流水</c-title>
		  <c-link @click="navigateTo('/account_record');">查看全部 <i class="tf tf-angle-right"></i></c-link>
	  </div>
	  
      <c-table ref="table" height="grow">
        <c-table-column
            label="收支记录号"
            name="record_number"
            width="140"
        ></c-table-column>

        <c-table-column
            label="交易摘要"
            name="remark"
            width="270"
        ></c-table-column>

        <c-table-column
            label="交易时间"
            name="create_date"
            width="140"
        ></c-table-column>

        <c-table-column
            label="收支类型"
            name="record_type"
            width="70"
        >
        </c-table-column>

        <c-table-column
            label="交易金额"
            name="money"
            width="70"
        ></c-table-column>

        <c-table-column
            label="余额"
            width="80"
            name="surplus_money"
        ></c-table-column>

        <!-- <c-table-column
            label="待结算金额"
            width="90"
            name="settle_amount"
        ></c-table-column> -->

        <!-- <c-table-column
          label="业务流水号"
          name="turnover_number"
          width="140"
        ></c-table-column> -->

        <c-table-column
            label="业务单号"
            name="business_number"
            width="140"
        ></c-table-column>

        <!-- <c-table-column
          label="收付类型"
          name="turnover_type"
          width="70"
        ></c-table-column> -->

        <c-table-column
            label="业务类型"
            width="90"
            name="business_type"
        >
          <template v-slot="{data}">
            {{businessTypeName[data.business_type]}}
          </template>
        </c-table-column>
      </c-table>
    </module>
  </page>
</template>

<script>
export default {
  data() {
    return {
      account: {},
      businessTypeName :{
        1:'销售订单',
        2:'销售退款单',
        3:'销售退货单',
        4:'资金充值',
        5:'资金扣减',
        6:'资金提现'
      },
    }
  },
  mounted() {
    this.loadAccount();
  },
  methods: {
    loadAccount() {
      this.request({
        url: '/stationed/account/info',
        data: {},
        loading: false,  // 是否显示loading，
        success: data => {
          this.account = data;
        }
      });

      this.$refs.table.load({
        url: '/stationed/account/record/list'
      });
    }
  }
}
</script>

<style lang="stylus" scoped>
	.account {
		padding: 26px 20px;

		.item {
			box-sizing: border-box;
			height: 120px;
			padding: 15px;
			background: #FAF9FC;
			
			&:nth-child(n+2) {
				margin-left: 25px;
			}
			
			> div {
				height: 100%;
			}

			label {
				display: block;
				margin: 15px 0 16px;
				font-size: 14px;
				color: #666;
			}

			strong {
				font-size: 30px;
				font-weight: bold;
			}
			
			span {
				margin-left: 16px;
				font-size: 13px;
				color: #666;
			}
		}
	}
</style>
